const SadMacIcon = () => {
  return (
    <svg
      width="95"
      height="124"
      viewBox="0 0 95 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 2L92 2" stroke="black" strokeWidth="4" />
      <path d="M16 14L80 14" stroke="black" strokeWidth="4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4H4V12V64V104H16H80H91V64V12V4H80H16ZM80 12H16V64H80V12Z"
        fill="#C4C4C4"
      />
      <rect x="16" y="16" width="64" height="48" fill="#CBCCFE" />
      <path d="M93 104L93 3.99999" stroke="black" strokeWidth="4" />
      <path d="M2 104L2 4" stroke="black" strokeWidth="4" />
      <path d="M14 64L14 16" stroke="black" strokeWidth="4" />
      <path d="M82 64L82 16" stroke="white" strokeWidth="4" />
      <path d="M30 32V24" stroke="black" strokeWidth="4" />
      <path d="M66 32V24" stroke="black" strokeWidth="4" />
      <path d="M50 44L50 24" stroke="black" strokeWidth="4" />
      <path d="M49 42H44" stroke="black" strokeWidth="4" />
      <path d="M60 54H36" stroke="black" strokeWidth="4" />
      <path d="M64 58H60" stroke="black" strokeWidth="4" />
      <path d="M36 58H32" stroke="black" strokeWidth="4" />
      <path d="M80 86H48" stroke="black" strokeWidth="4" />
      <g filter="url(#filter0_d)">
        <path d="M20 94H12" stroke="#18AB1C" strokeWidth="4" />
      </g>
      <g filter="url(#filter1_d)">
        <path d="M20 98H12" stroke="#BF4131" strokeWidth="4" />
      </g>
      <path d="M80 90H48" stroke="white" strokeWidth="4" />
      <rect x="4" y="104" width="88" height="20" fill="black" />
      <rect x="8" y="108" width="44" height="4" fill="#575757" />
      <rect x="44" y="108" width="44" height="4" fill="#222222" />
      <rect x="64" y="112" width="24" height="4" fill="#222222" />
      <rect x="76" y="116" width="12" height="4" fill="#222222" />
      <rect x="8" y="112" width="32" height="4" fill="#575757" />
      <rect x="8" y="116" width="44" height="4" fill="#575757" />
      <rect x="40" y="112" width="24" height="4" fill="#444444" />
      <path d="M16 66L80 66" stroke="white" strokeWidth="4" />
      <defs>
        <filter
          id="filter0_d"
          x="4"
          y="84"
          width="24"
          height="20"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.690196 0 0 0 0 0.952941 0 0 0 0 0.658824 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d"
          x="4"
          y="88"
          width="24"
          height="20"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.745098 0 0 0 0 0.72549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default SadMacIcon;
